import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { Wrapper, Title, CheckListBlock } from './styled';
import TotalTitle from './TotalTitle';
import CheckList from './CheckList';
import Form from './Form';
import PromoForm from './PromoForm/index';
import { cityGetProp, PROMOCODE_REQUEST } from '~/src/helpers/city';

const CheckAndRequest = (
    {
        checkList = { total: 0, data: {} },
        isAuth,
        idForm = 'request_form',
        id,
        isSideBar = false,
        adviseEquipment = { total: 0, list: [] },
        requiredEquipment = { total: 0, list: [] },
        title = '',
        cityIn,
        currentCity,
        backgroundColor,
        maxWidth,
        className,
        textBottomForm = null,
        isPaddingText,
        displaceOncePrice = true,
    },
) => {

    const [promoState, setPromoState] = useState({ title: '', promo: '' });

    const setCampaignTitleAndPromo = (title, promo) => {
        setPromoState({ title, promo });
    };

    const renderPromo = () => {
        return cityGetProp(currentCity, PROMOCODE_REQUEST);
    };

    const { total, data = {} } = checkList;
    const {
        monthly = { total: 0, list: [] },
        once = { total: 0, list: [] },
        selfOrder = false,
        fullSaleId,
    } = data;

    once.list = useMemo(() => once.list.filter(item => item.price > 0), [once]);
    monthly.list = useMemo(() => monthly.list.filter(item => item.price > 0), [monthly]);

    const isClearCheck = !!((monthly.list.length === 0 && once.list.length === 0));
    const initialTitle = `Заявка на подключение в ${cityIn}`;
    const defaultTitle = isClearCheck ? initialTitle : 'Итого к оплате';
    const equipmentTotal = adviseEquipment.total;

    return (
        <Wrapper
            id={id}
            isSideBar={isSideBar}
            backgroundColor={backgroundColor}
            maxWidth={maxWidth}
            className={className}
        >

            {title && <Title isSideBar={isSideBar}>{title}</Title>}

            <TotalTitle
                total={total + equipmentTotal.toString()}
                isSideBar={isSideBar}
                title={defaultTitle}
            />

            <CheckListBlock>
                {
                    monthly.list.length > 0 &&
                    <CheckList
                        title={'Ежемесячный платеж'}
                        total={monthly.total}
                        list={monthly.list}
                        isAuth={isAuth}
                        priceText={'₽/мес'}
                        isSideBar={isSideBar}
                        isPaddingText={isPaddingText}
                    />
                }

                {
                    adviseEquipment.list?.length > 0 &&
                    <CheckList
                        title={'Рекомендуемое оборудование'}
                        total={equipmentTotal.toString()}
                        list={adviseEquipment.list}
                        isAuth={isAuth}
                        priceText={'₽/мес'}
                        isPaddingText={isPaddingText}
                    />
                }

                {
                    requiredEquipment.list?.length > 0 &&
                    <CheckList
                        title={'Входит в стоимость тарифа'}
                        list={requiredEquipment.list}
                        isAuth={isAuth}
                        isPaddingText={isPaddingText}
                    />
                }

                {
                    once.list.length > 0 &&
                    <CheckList
                        title={'Разовый платеж'}
                        total={displaceOncePrice && once.total}
                        list={once.list}
                        isAuth={isAuth}
                        priceText={displaceOncePrice && '₽'}
                        isPaddingText={isPaddingText}
                    />
                }
            </CheckListBlock>

            {
                ((monthly.list.length > 0) || (adviseEquipment?.list?.length > 0) || (once.list.length > 0)) &&
                renderPromo()
                    ? <PromoForm domain={currentCity.domain} addTitleToRequest={setCampaignTitleAndPromo}/>
                    : null
            }

            <Form
                idForm={idForm}
                isAuth={isAuth}
                isSideBar={isSideBar}
                checkList={checkList}
                adviseEquipment={adviseEquipment}
                campaign_title={promoState.title}
                promo={promoState.promo}
                textBottomForm={textBottomForm}
                selfOrder={selfOrder}
                fullSaleId={fullSaleId}
                requiredEquipment={requiredEquipment}
            />
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    cityIn: state.city.currentCity.cityIn,
    currentCity: state.city.currentCity,
});

export default connect(mapStateToProps)(CheckAndRequest);
